<template>
    <!--
        props 
        1.format : 눈에 보이는 날짜형식 포멧팅 / default는 일자(yyyy-MM-dd) , 일시로 보여지고 싶은경우  yyyy/MM/dd hh:mm:ss
        2.enableTime : 시간설정 기능 일시 데이터를 조작해야하는 경우 사용 / default는 노출x (false)
        3.frmType : return 받을 데이터 포멧 형식

        v-model
        Date 형식
    -->
    <VueDatePicker v-if="props.inline"
        ref="datePickerRef"
        :weekStart="0"
        inline
        locale="ko-KR"
        :format-locale="ko"
        :inputFormat="props.format"
        :clearable="true"
        :format="props.format"
        :enable-time-picker="props.enableTime"
        v-model="selectDate"
        :text-input="props.textable"
        :min-date="minDate"
        :max-date="maxDate"
        :year-picker="props.yearPicker"
        auto-apply
        @update:model-value="setDate"
     />
     <VueDatePicker v-if="!props.inline && props.monthMinMaxDate"
        ref="datePickerRef"
        :weekStart="0"
        locale="ko-KR"
        :format-locale="ko"
        :inputFormat="props.format"
        :clearable="true"
        :format="props.format"
        :enable-time-picker="props.enableTime"
        v-model="selectDate"
        :text-input="props.textable"
        :disabled-dates="disableDateByMonth"
        :year-picker="props.yearPicker"
        auto-apply
        @update:model-value="setDate"
     />
     <VueDatePicker v-else-if="props.format =='yyyy'"
        ref="datePickerRef"
        :weekStart="0"
        locale="ko-KR"
        :format-locale="ko"
        :inputFormat="props.format"
        :clearable="true"
        :format="props.format"
        :enable-time-picker="props.enableTime"
        v-model="selectDate"
        :text-input="props.textable"
        :min-date="minDate"
        :max-date="maxDate"
        :year-picker="props.yearPicker"
        auto-apply
        @update:model-value="setDate"
        :year-range="[Number(minDate), Number(maxDate)]"
     />
    <VueDatePicker v-else
        ref="datePickerRef"
        :weekStart="0"
        locale="ko-KR"
        :format-locale="ko"
        :inputFormat="props.format"
        :clearable="true"
        :format="props.format"
        :enable-time-picker="props.enableTime"
        v-model="selectDate"
        :text-input="props.textable"
        :min-date="minDate"
        :max-date="maxDate"
        :year-picker="props.yearPicker"
        auto-apply
        @update:model-value="setDate"
     />

</template>


<script setup>
import {ref,watch,computed} from 'vue'
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import { ko } from 'date-fns/locale';
import common from '@/js/common';

const props = defineProps({
    modelValue: {
        type: [String,Number],
        default: null,
    },
    frmType: String,
    format : {
        type : String,
        default : 'yyyy-MM-dd'
        //format 일시  => yyyy/MM/dd hh:mm:ss
    },
    enableTime : {
        type : Boolean,
        default : false
    },
    selectDate : {
        type : [String,Number],
        default : ''
    },
    textable : {
        type : Boolean,
        default : true
    },
    minDate : {
        type : String,
        default : ''
    },
    maxDate : {
        type : String,
        default : ''
    },
    yearPicker:{
        type : Boolean,
        default : false
    },
    inline:{
        type : Boolean,
        default : false
    },
    monthMinMaxDate : {
        default: false
    }
})
const emits = defineEmits(['return'])
// const inputFormat = ref('yyyy-MM-dd');
let selectDate = ref(props.selectDate)
const datePickerRef = ref()

//년도 선택이면 default +- 10년 셋팅
const minDate = computed(()=>{
    return props.yearPicker ?  `${Number(new Date().getFullYear()) - 10}` : props.minDate
})
const maxDate = computed(()=>{

    return props.yearPicker ? `${Number(new Date().getFullYear()) + 11}` :  props.maxDate
})


const disableDateByMonth = computed(() => {
  
    return (dateToRender) => {
        if (!props.monthMinMaxDate) {
            return false;
        }

        const masterRuleDate = new Date(props.monthMinMaxDate);
        const ruleMonth = masterRuleDate.getMonth();
        const ruleDay = masterRuleDate.getDate();
        const renderYear = dateToRender.getFullYear();
        const yearlyRuleDate = new Date(renderYear, ruleMonth, ruleDay);
        const minAllowedDate = new Date(yearlyRuleDate);
        minAllowedDate.setDate(yearlyRuleDate.getDate() - 31);

        const maxAllowedDate = new Date(yearlyRuleDate);
        maxAllowedDate.setDate(yearlyRuleDate.getDate() + 31);


        minAllowedDate.setHours(0, 0, 0, 0);
        maxAllowedDate.setHours(23, 59, 59, 999);


        if (dateToRender < minAllowedDate || dateToRender > maxAllowedDate) {
            return true; 
        }

        return false;
    };
});

watch(
  () => props.selectDate,
  (newVal) => {
    selectDate.value = newVal
  }
)





const setDate = (date) => {
    if(date && date instanceof Date){
        let year = date.getFullYear();
        let month = ('0' + (date.getMonth() + 1)).slice(-2);
        let day = ('0' + date.getDate()).slice(-2);
        let hour =('0' +  date.getHours()).slice(-2); 
        let min = ('0' +  date.getMinutes()).slice(-2);  
        let second = ('0' +  date.getSeconds()).slice(-2);  

        let dateStr = '';

        switch(props.frmType) {
            case 'Y':
                dateStr = year;
                break;
            case 'YM':
                dateStr = `${year}-${month}`;
                break;
            case 'YMD':
                dateStr = `${year}-${month}-${day}`;
                break
            //case 'PYMD':
            //    dateStr = `${year}-${pmonth}-${day}`; // 현재날짜 한달 뒤
            //    break
            case 'YMDT':
                dateStr = `${year}-${month}-${day} ${hour}:${min}:${second}`;
                break
            default:
                dateStr = `${year}-${month}-${day}`;
                break;
        }
        selectDate.value = dateStr
    }
    emits('return',selectDate.value)
}

defineExpose({
    setDate
})
</script>